export enum SubscribeModalScreenName {
  SelectPlan = 'select-plan',
  Safelist = 'safelist',
  Welcome = 'welcome',
  ProUpsell = 'pro-upsell',
}

export interface UpgradeReason {
  id: string;
  label: string;
}
